import React from 'react';
import { Box, Skeleton, Stack, Typography } from '@mui/material';
import { EPageTypes } from 'shared/types/common.interface';

type DebateSkeletonProps = {
  type?: EPageTypes.debate | EPageTypes.stream;
};

const DebateSkeleton: React.FunctionComponent<DebateSkeletonProps> = ({ type }) => (
  <Stack width="100%" pb="140px">
    <Stack
      width="100%"
      pb="40px"
      columnGap="26px"
      rowGap="20px"
      sx={{ flexDirection: { md: 'row', sm: 'column', sx: 'column' } }}
    >
      {[...new Array(type === EPageTypes.stream ? 1 : 2)].map((_, index) => (
        <Box key={index} width="100%">
          <Skeleton
            variant="rectangular"
            width="100%"
            sx={{
              borderRadius: '8px',
              height: { lg: '57vh', md: '34vh', sm: '30vh' },
              '@media (max-width:500px)': {
                height: '22vh',
              },
              maxHeight: '609px',
            }}
          />
          {(type === EPageTypes.stream || type === EPageTypes.debate) && (
            <Skeleton
              variant="rectangular"
              width="100%"
              sx={{
                borderRadius: '8px',
                mt: '16px',
                height: { md: '23px', sm: '16px', xs: '16px' },
              }}
            />
          )}
        </Box>
      ))}
    </Stack>
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{ display: { lg: 'flex', md: 'none', sm: 'none', xs: 'none' } }}
    >
      <Stack direction="row" columnGap="24px" flexWrap="wrap">
        <Skeleton variant="rectangular" width={80} height={40} sx={{ borderRadius: '8px' }} />
        {[...new Array(3)].map((_, index) => (
          <Stack key={index} columnGap="24px" rowGap="24px" sx={{ borderRadius: '8px' }}>
            <Stack direction="row" columnGap="8px">
              <Skeleton variant="rectangular" width={24} height={24} sx={{ borderRadius: '8px' }} />
              <Box>
                <Skeleton
                  variant="rectangular"
                  width={125}
                  height={25}
                  sx={{ borderRadius: '8px', mb: '4px' }}
                />
                <Skeleton
                  variant="rectangular"
                  width={70}
                  height={20}
                  sx={{ borderRadius: '8px' }}
                />
              </Box>
            </Stack>
          </Stack>
        ))}
      </Stack>
      <Stack direction="row" columnGap="16px">
        <Skeleton variant="rectangular" width={100} height={56} sx={{ borderRadius: '8px' }} />
        <Skeleton variant="rectangular" width={24} height={56} sx={{ borderRadius: '8px' }} />
      </Stack>
    </Stack>
    <Stack direction="row" justifyContent="space-between" mt="24px" mb="16px" alignItems="center">
      <Typography variant="h1" color="secondary.main" width="60%">
        <Skeleton variant="text" />
      </Typography>
      <Skeleton
        variant="rectangular"
        width={80}
        height={30}
        sx={{ display: { lg: 'none', md: 'box', sm: 'box', xs: 'box', borderRadius: '8px' } }}
      />
    </Stack>
    <Typography variant="body2" color="text.secondary">
      <Skeleton variant="text" width="70%" />
    </Typography>
    <Typography variant="body2" color="text.secondary">
      <Skeleton variant="text" width="70%" />
    </Typography>
    <Typography variant="body2" color="text.secondary">
      <Skeleton variant="text" width="70%" />
    </Typography>
    <Stack
      direction="row"
      columnGap="24px"
      rowGap="24px"
      sx={{
        display: { lg: 'none', md: 'flex', sm: 'flex', xs: 'flex' },
        mt: '24px',
        flexWrap: 'wrap',
      }}
    >
      {[...new Array(3)].map((_, index) => (
        <Stack key={index} columnGap="24px" rowGap="24px">
          <Stack direction="row" columnGap="8px">
            <Skeleton variant="rectangular" width={22} height={22} sx={{ borderRadius: '8px' }} />
            <Box>
              <Skeleton
                variant="rectangular"
                width={125}
                height={17}
                sx={{ borderRadius: '8px', mb: '4px' }}
              />
              <Skeleton variant="rectangular" width={70} height={14} sx={{ borderRadius: '8px' }} />
            </Box>
          </Stack>
        </Stack>
      ))}
    </Stack>
    <Stack
      direction="row"
      columnGap="8px"
      sx={{ display: { lg: 'none', md: 'flex', sm: 'flex', xs: 'flex' }, mt: '40px' }}
    >
      <Skeleton
        variant="rectangular"
        height={46}
        sx={{ borderRadius: '8px', width: { md: '40%', sm: '100%', xs: '100%' } }}
      />
      <Skeleton variant="rectangular" width={24} height={46} sx={{ borderRadius: '8px' }} />
    </Stack>
  </Stack>
);

export default DebateSkeleton;
